import { createFileRoute } from '@tanstack/react-router'

import { CaseStudyLayout } from '../components/CaseStudyLayout'
import { telescope } from '../caseStudies/telescope'
import { caseStudyHead } from '../caseStudySeo'

export const Route = createFileRoute('/Telescope')({
  head: () => caseStudyHead(telescope.content),
  component: TelescopePage,
})

function TelescopePage() {
  return <CaseStudyLayout content={telescope.content} />
}
